<template>
  <div>
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4 mob-hidden"
    />
    <TeamDetailsPopup
      :isActive="isDetailsActive"
      :selectedTesimonial="selectedTesimonial"
      @close="toggleDetails"
    />

    <!-- Teams -->
    <div class="lg:mt-0 md:mt-0 mt-20">
      <div class="teamsbg absolute lg:block md:block hidden">
        <div class="relative">
          <div class="absolute top-2 -right-10">
            <img
              src="../../../assets/images/bg-des/team-bg-t1.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
          <div class="absolute top25rem left-14">
            <img
              src="../../../assets/images/bg-des/team-bg-t2.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
        </div>
      </div>
      <div class="relative relative lg:top-16 top-0">
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10"
          v-if="board_of_directors.length"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Board Members - Friends of Caregiver Saathi
          </p>
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-8 lg:gap-8 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3 cursor-pointer"
              v-for="(item, index) in board_of_directors"
              :key="'item-' + index"
            >
              <div>
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  @click="toggleDetails(true, item)"
                  class="rounded-full md:h-28 lg:h-28 h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                />
                <div class="flex justify-center items-center gap-2">
                  <p
                    class="team-mbr-name text-center text-black"
                    @click="toggleDetails(true, item)"
                  >
                    <span class="uppercase">{{ item.name }} </span>
                  </p>
                  <a
                    :href="item.linkedIn"
                    v-if="
                      item.hasOwnProperty('linkedIn') && item.linkedIn != ''
                    "
                    target="_blank"
                  >
                    <img
                      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/linkedin.png"
                      class="w-4 h-4 object-contain mb-1"
                    />
                  </a>
                </div>
                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10 pt-20"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Team - Caregiver Saathi
          </p>
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-8 lg:gap-8 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3 cursor-pointer"
              v-for="(item, index) in teams"
              :key="'item-' + index"
            >
              <div @click="toggleDetails(true, item)">
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  class="rounded-full md:h-28 lg:h-28 h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                />
                <p class="team-mbr-name text-center text-black">
                  <span class="uppercase"> {{ item.name }}</span>
                </p>

                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Mentors -->
    <!-- <div class="mt-40">
      <div class="flex justify-end">
        <div class="mentorsbg absolute">
          <div class="relative">
            <div class="absolute right-16 trans-rotate-31">
              <img
                src="../../../assets/images/bg-des/team-bg-t1.svg"
                alt="bg-polygon"
                class=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="relative">
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Mentors - Caregiver Saathi
          </p>

          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-10 lg:gap-10 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3"
              v-for="(item, index) in mentor"
              :key="'item-' + index"
            >
              <div>
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  class="rounded-full md:h-28 lg:h-28 cursor-pointer h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                  @click="toggleDetails(true, item)"
                />

                <div class="flex justify-center items-center gap-2">
                  <p
                    class="team-mbr-name text-center text-black cursor-pointer"
                    @click="toggleDetails(true, item)"
                  >
                    <span class="uppercase"> {{ item.name }}</span>
                  </p>
                  <a :href="item.linkedIn" v-if="item.linkedIn" target="_blank">
                    <img
                      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/linkedin.png"
                      class="w-4 h-4 object-contain mb-1"
                    />
                  </a>
                </div>
                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Council Advisors -->
    <!-- <div class="pt-20 pb-20">
      <div class="teamsbg absolute">
        <div class="relative">
          <div class="absolute top-2 -right-10">
            <img
              src="../../../assets/images/bg-des/team-bg-t1.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
          <div class="absolute top25rem left-14">
            <img
              src="../../../assets/images/bg-des/team-bg-t2.svg"
              alt="bg-polygon"
              class=""
            />
          </div>
        </div>
      </div>
      <div class="relative top-16">
        <div
          class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-6 mx-auto m5rem z-10"
        >
          <p
            class="title sm-fsize16 md:font-normal lg:font-normal font-bold pb-8"
          >
            Council of Advisors - Caregiver Saathi
          </p>

          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-2 grid-rows-2 md:gap-10 lg:gap-10 gap-4 mt-10"
          >
            <div
              class="w-full rounded-xl border15px-res bgdcf1f3"
              v-for="(item, index) in advisors"
              :key="'item-' + index"
            >
              <div>
                <img
                  :src="
                    item.image
                      ? `${$imageURL}/${item.image}`
                      : require(`@/assets/images/AuthorImage.jpg`)
                  "
                  class="rounded-full md:h-28 lg:h-28 h-20 md:w-28 lg:w-28 w-20 md:my-6 lg:my-6 my-3 mx-auto object-cover"
                  alt="UserImg"
                  @click="toggleDetails(true, item)"
                />
                <div class="flex justify-center items-center gap-2">
                  <p
                    class="team-mbr-name text-center text-black"
                    @click="toggleDetails(true, item)"
                  >

                    <span class="uppercase"> {{ item.name }}</span>
                  </p>
                  <a :href="item.linkedIn" v-if="item.linkedIn" target="_blank">
                    <img
                      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi-new/image/linkedin.png"
                      class="w-4 h-4 object-contain mb-1"
                    />
                  </a>
                </div>
                <p class="pt-2 team-mbr-des text-center md:mb-6 lg:mb-6 mb-2">
                  {{ item.designation ? item.designation : "" }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import TeamDetailsPopup from "./TeamDetailsPopup";
import { mapState } from "vuex";
export default {
  components: {
    TeamDetailsPopup,
  },
  data() {
    return {
      editModal: false,
      isDetailsActive: false,
      selectedTesimonial: {},
      board_of_directors: [],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    async getAboutUs() {
      // let curPage = this.currentPage - 1;
      let payload = {
        limit: 1000,
        offset: 0,
        sortBy: 1,
      };
      let loader;
      // if (this.search !== "")
      //   Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading();
        const getAboutUs = await this.$store.dispatch(
          "aboutUs/getAboutUs",
          payload
        );
        // console.log(getAuthor);
        loader.close();
        // this.totalRows = this.aboutUs.totalCount;
        let aboutUsData = this.aboutUs.result;
        this.teams = aboutUsData.filter((data) => data.category === "team");
        this.mentor = aboutUsData.filter((data) => data.category === "mentor");
        this.advisors = aboutUsData.filter(
          (data) => data.category === "advisor"
        );
        this.board_of_directors = aboutUsData.filter(
          (data) => data.category === "board members"
        );
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getAboutUs();
  },
  computed: {
    ...mapState("aboutUs", {
      aboutUs: "aboutUs",
    }),
  },
};
</script>
